import { Box, Grid, RadioGroup, FormControlLabel, FormControl, Radio, Tabs, Tab } from '@mui/material'
import tiers from './priceData'
import styles from './PricingPlans.module.css'
import PlanCard from './PlanCard'
import React, { useState } from 'react'
import NavBar from '../home/NavBar'
import { useTranslation } from 'react-i18next'

export default function PricingPlans() {
  const [planType, setPlanType] = useState('business')
  const [planPeriod, setPlanPeriod] = useState('annual')
  const { t } = useTranslation()

  const handleTabs = (name, value) => {
    setPlanType(value)
  }

  return (
    <>
      <NavBar></NavBar>

      <div className className={styles.container}>
        <div className={styles.container_inner}>
          <Box className={styles.bar} sx={{ border: 1, borderColor: 'whitesmoke', borderRadius: 3 }}>
            <Tabs
              sx={{
                borderRadius: 3,
                '& .MuiTabs-indicator': {
                  display: 'none'
                },
                '& .Mui-selected': {
                  color: 'blue',
                  backgroundColor: 'whitesmoke'
                },
                '& .MuiButtonBase-root.MuiTab-root': {
                  textTransform: 'capitalize',
                  color: 'black',
                  fontSize: '1.1vw',
                  fontWeight: 'bold'
                }
              }}
              value={planType}
              onChange={handleTabs}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
            >
              <Tab value="business" label={t('businessOwner')} />
              <Tab value="designer" label={t('designer/Agency')} />
            </Tabs>

            <FormControl component="fieldset">
              <RadioGroup
                row
                name="row-radio-buttons-group"
                value={planPeriod}
                onChange={e => setPlanPeriod(e.target.value)}
              >
                <FormControlLabel value="annual" control={<Radio />} label={<p>{t('annualPlan')}</p>} />
                <FormControlLabel value="monthly" control={<Radio />} label={<p>{t('monthlyPlan')}</p>} />
              </RadioGroup>
            </FormControl>
          </Box>

          <Grid container spacing={2}>
            {tiers.map(tier => (
              <Grid item key={tier} xs={12} md={3}>
                <PlanCard key={tier} tier={tier}></PlanCard>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </>
  )
}
